module.exports = __webpack_public_path__ + "images/花筑pr长图_06-2.jpg?v=ea633033";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_06-2.jpg
 ** module id = 22
 ** module chunks = 1 2
 **/